// Configurazione della Cookie Solution di Iubenda:
// https://www.iubenda.com/en/help/1205-how-to-configure-your-cookie-solution-advanced-guide
const iubendaConfig = {
  siteId: 3594849,
  cookiePolicyId: 61241276,
  lang: 'it',
  floatingPreferencesButtonDisplay: 'anchored-bottom-left',
  banner: {
    position: 'float-bottom-right',
    acceptButtonDisplay: true,
    acceptButtonCaption: 'Accetta',
    customizeButtonDisplay: true,
    customizeButtonCaption: 'Scopri di più e personalizza',
  },
  preferenceCookie: {
    expireAfter: 180,
  },
  enableGdpr: true,
  gdprAppliesGlobally: true,
  gdprApplies: true,
  perPurposeConsent: true,
  purposes: '1, 2, 3, 4, 5',
}

export default iubendaConfig
